import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ROLE } from 'constant'
import { Tenant, User } from './type'

type InitialState = {
  loggedInUser: boolean
  user: User | null
  isAdmin: boolean
  tenant: Tenant | null
}

const initialState: InitialState = {
  loggedInUser: false,
  user: null,
  isAdmin: false,
  tenant: null,
}
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    /**
     * status login success
     */
    loginSuccess(state: InitialState) {
      state.loggedInUser = true
    },
    /**
     * data user login
     */
    userLogin(state: InitialState, action: PayloadAction<{ user: any }>) {
      // Handle both login response (data contains user + current_tenant) and refresh response
      const userData = action.payload.user.user || action.payload.user
      const currentTenant = action.payload.user.current_tenant || null

      state.user = userData
      state.isAdmin = userData.user_type === ROLE.ADMIN
      state.tenant = currentTenant
    },
    /**
     * logout+
     */
    userLogout(state: InitialState) {
      state.user = initialState.user
      state.loggedInUser = false
    },
    userUpdateAgentGuide(
      state: InitialState,
      action: PayloadAction<{ user: User }>,
    ) {
      state.user = action.payload.user
    },
  },
})

export default authSlice

export const { loginSuccess, userLogin, userLogout, userUpdateAgentGuide } =
  authSlice.actions
